import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../../components/PaginationAdvanced";
import Search from "../../components/Search";
import { toastr } from "react-redux-toastr";
import * as Constants from '../../constants';
import { FormControl } from "react-bootstrap";

import Index from "../Index";
import { fetchCompanies, enableCompany, disableCompany, changeCompanyIp, pokeCompanyLeadRouterRelation, changeCompanyDomain } from "../../actions/index";

class AdminCompanies extends Index {
  static propTypes = {
    fetchCompanies: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    companies: PropTypes.object,
    match: PropTypes.object.isRequired,
    enableCompany: PropTypes.func.isRequired,
    pokeCompanyLeadRouterRelation: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchCompanies(this.serialize(newQueries));
    this.props.history.push(`/admin/companies${this.serialize(newQueries)}`);
  }

  loginAs(e) {
    let siteUUID = e.target.dataset.siteUuid;
    localStorage.setItem('lastSiteUUID', siteUUID);
    this.props.history.push(`/`);
  }

  enable(e) {
    let siteUUID = e.target.dataset.siteUuid;
    this.props.enableCompany(siteUUID).then(company => {
      if (company.payload != undefined) {
        if (company.payload.status == 200) {
          this.fetchData();
          toastr.success(company.payload.data);
        } else {
          toastr.error(company.payload.data);
        }
      }
    });
  }

  disable(siteUUID) {
    this.props.disableCompany(siteUUID).then(company => {
      if (company.payload != undefined) {
        if (company.payload.status == 200) {
          this.fetchData();
          toastr.success(company.payload.data);
        } else {
          toastr.error(company.payload.data);
        }
      }
    });
  }

  onDisableClickConfirmation(e) {
    let siteUUID = e.target.dataset.siteUuid;
    const msg =
      "Are you sure you want to disable this company?";
    const toastrConfirmOptions = {
      onOk: () => this.disable(siteUUID)
    };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  pokeLeadRouterRelation(e) {
    let siteUUID = e.target.dataset.siteUuid;
    this.props.pokeCompanyLeadRouterRelation(siteUUID).then(response => {
      if (response.payload != undefined) {
        if (response.payload.status == 200) {
          toastr.success(response.payload.data);
        } else {
          toastr.error(response.payload.data);
        }
      }
    });
  }

  handleChangeDomain(e) {
    let siteUUID = e.target.dataset.siteUuid;
    this.props.changeCompanyDomain(siteUUID).then(response => {
      if (response.payload != undefined) {
        if (response.payload.status == 200) {
          toastr.success(response.payload.data);
        } else {
          toastr.error(response.payload.data);
        }
      }
    });
  }

  handleChangeIp(e) {
    let site_uuid = e.target.dataset.siteUuid;
    let ip = e.target.value;
    if (
      confirm(
        "Are you sure you want to change the mailgun ip address this company uses?"
      )
    ) {
      this.props
        .changeCompanyIp(site_uuid, {
          ip: ip
        })
        .then(response => {
        if (response.payload != undefined) {
          if (response.payload.status == 200) {
            toastr.success(response.payload.data);
            this.fetchData();
          } else {
            toastr.error(response.payload.data);
          }
        }
      });
    }
  }


  renderCompanies() {
    if (!this.props.companies.data) {
      return <div />;
    }
    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th colSpan={9}>&nbsp;</th>
            <th colSpan={8}>Drips</th>
            <th colSpan={8}>Eblasts</th>
          </tr>
          <tr>
            <th>Domain/Site UUID</th>
            <th>Status</th>
            <th>TOS</th>
            <th
              className="text-right"
              data-sort="reports.campaigns_count"
              onClick={this.handleOrder.bind(this)}
            >
              Work<br/>flows
            </th>
            <th
              className="text-right"
              data-sort="reports.email_templates_count"
              onClick={this.handleOrder.bind(this)}
            >
              Email Temp.
            </th>
            <th
              className="text-right"
              data-sort="reports.eblasts_count"
              onClick={this.handleOrder.bind(this)}
            >
              eBlasts
            </th>
            <th
              className="text-right"
              data-sort="reports.sent_emails_count"
              onClick={this.handleOrder.bind(this)}
            >
              Sent Emails
            </th>
            <th
              className="text-right"
              data-sort="reports.subscriptions_count"
              onClick={this.handleOrder.bind(this)}
            >
              Subs
            </th>
            <th
              className="text-right"
              data-sort="reports.bounce_rate"
              onClick={this.handleOrder.bind(this)}
            >
              Bounce%
            </th>

            <th
              className="borderleft text-right"
              data-sort="reports.drip_delivered_count"
              onClick={this.handleOrder.bind(this)}
            >
              Deliv.
            </th>
            <th
              className="text-right"
              data-sort="reports.drip_opened_count"
              onClick={this.handleOrder.bind(this)}
            >
              Open
            </th>
            <th
              className="text-right"
              data-sort="reports.drip_clicked_count"
              onClick={this.handleOrder.bind(this)}
            >
              Click
            </th>
            <th
              className="text-right"
              data-sort="reports.drip_unsubscribed_count"
              onClick={this.handleOrder.bind(this)}
            >
              Unsub
            </th>
            <th
              className="text-right"
              data-sort="reports.drip_complained_count"
              onClick={this.handleOrder.bind(this)}
            >
              SPAM
            </th>
            <th
              className="text-right"
              data-sort="reports.drip_bounced_count"
              onClick={this.handleOrder.bind(this)}
            >
              Bounce
            </th>
            <th
              className="text-right"
              data-sort="reports.drip_dropped_count"
              onClick={this.handleOrder.bind(this)}
            >
              Drop
            </th>
            <th
              className="text-right"
              data-sort="reports.drip_bounce_rate"
              onClick={this.handleOrder.bind(this)}
            >
              Bounce%
            </th>

            <th
              className="borderleft text-right"
              data-sort="reports.eblast_delivered_count"
              onClick={this.handleOrder.bind(this)}
            >
              Deliv.
            </th>
            <th
              className="text-right"
              data-sort="reports.eblast_opened_count"
              onClick={this.handleOrder.bind(this)}
            >
              Open
            </th>
            <th
              className="text-right"
              data-sort="reports.eblast_clicked_count"
              onClick={this.handleOrder.bind(this)}
            >
              Click
            </th>
            <th
              className="text-right"
              data-sort="reports.eblast_unsubscribed_count"
              onClick={this.handleOrder.bind(this)}
            >
              Unsub
            </th>
            <th
              className="text-right"
              data-sort="reports.eblast_complained_count"
              onClick={this.handleOrder.bind(this)}
            >
              SPAM
            </th>
            <th
              className="text-right"
              data-sort="reports.eblast_bounced_count"
              onClick={this.handleOrder.bind(this)}
            >
              Bounce
            </th>
            <th
              className="text-right"
              data-sort="reports.eblast_dropped_count"
              onClick={this.handleOrder.bind(this)}
            >
              Drop
            </th>
            <th
              className="text-right"
              data-sort="reports.eblast_bounce_rate"
              onClick={this.handleOrder.bind(this)}
            >
              Bounce%
            </th>

            <th
              className="text-right"
              data-sort="reports.mailgun_ips"
              onClick={this.handleOrder.bind(this)}
            >
              IP
            </th>

            <th className="borderleft text-right">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {this.props.companies.data.map(this.renderCompany.bind(this))}
        </tbody>
      </table>
    );
  }

  renderCompany(company) {
    let statusLabel =
      company.status == "Enabled" ? "label-success" : "label-default";
    return (
      <tr key={company.site_uuid}>
        <td>
          <strong>{company.site_domain}</strong>
          <br />
          {company.site_uuid}
        </td>
        <td>
          <span className={`label ${statusLabel}`}>{company.status}</span>
        </td>
        <td>{company.latest_tos_accepted}</td>
        <td className="text-right">{company.report.campaigns_count}</td>
        <td className="text-right">{company.report.email_templates_count}</td>
        <td className="text-right">{company.report.eblasts_count}</td>
        <td className="text-right">{company.report.sent_emails_count}</td>
        <td className="text-right">{company.report.subscriptions_count}</td>
        <td className="text-right">
          {Math.round(company.report.bounce_rate * 1000) / 1000}
        </td>

        <td className="borderleft text-right">
          {company.report.drip_delivered_count}
        </td>
        <td className="text-right">{company.report.drip_opened_count}</td>
        <td className="text-right">{company.report.drip_clicked_count}</td>
        <td className="text-right">{company.report.drip_unsubscribed_count}</td>
        <td className="text-right">{company.report.drip_complained_count}</td>
        <td className="text-right">{company.report.drip_bounced_count}</td>
        <td className="text-right">{company.report.drip_dropped_count}</td>
        <td className="text-right">
          {Math.round(company.report.drip_bounce_rate * 1000) / 1000}
        </td>

        <td className="borderleft text-right">
          {company.report.eblast_delivered_count}
        </td>
        <td className="text-right">{company.report.eblast_opened_count}</td>
        <td className="text-right">{company.report.eblast_clicked_count}</td>
        <td className="text-right">
          {company.report.eblast_unsubscribed_count}
        </td>
        <td className="text-right">{company.report.eblast_complained_count}</td>
        <td className="text-right">{company.report.eblast_bounced_count}</td>
        <td className="text-right">{company.report.eblast_dropped_count}</td>
        <td className="text-right">
          {Math.round(company.report.eblast_bounce_rate * 1000) / 1000}
        </td>

        <td className="borderleft text-right">
          <FormControl
            componentClass="select"
            type="select"
            className="form-control ip_select"
            labelClassName=""
            wrapperClassName=""
            value={company.mailgun_ips}
            name="step_action"
            data-site-uuid={company.site_uuid}
            onChange={this.handleChangeIp.bind(this)}
          >
            {this.ipOptions(company.mailgun_ips)}
          </FormControl>
        </td>

        <td className="text-right borderleft">
          <a
            className="btn btn-xs btn-default m-l-10"
            data-site-uuid={company.site_uuid}
            onClick={this.loginAs.bind(this)}
          >
            Login
          </a>
          <a
            className="btn btn-xs btn-default m-l-10"
            data-site-uuid={company.site_uuid}
            onClick={this.enable.bind(this)}
          >
            Enable
          </a>
          <a
            className="btn btn-xs btn-default m-l-10"
            data-site-uuid={company.site_uuid}
            onClick={this.onDisableClickConfirmation.bind(this)}
          >
            Disable
          </a>
          <a
            className="btn btn-xs btn-default m-l-10"
            data-site-uuid={company.site_uuid}
            onClick={this.pokeLeadRouterRelation.bind(this)}
          >
            LR
          </a>
          <a
            className="btn btn-xs btn-default m-l-10"
            data-site-uuid={company.site_uuid}
            onClick={this.handleChangeDomain.bind(this)}
          >
            Domain
          </a>
        </td>
      </tr>
    );
  }

  ipOptions(selected_ip) {
    let ips = [
            { value: '146.20.113.248',  name:'146.20.113.248 (Welcome - Do not use)'},
            { value: '146.20.113.247',  name:'146.20.113.247 (Standby)'},
            { value: '161.38.198.237',  name:'161.38.198.237 (New)'},
            { value: '143.55.235.52',  name:'143.55.235.52 (New)'}
          ]
    let options = ips.map(ip => {
        let selected = "";
        if (selected_ip == ip.value) {
          selected = "selected";
        }
        return (
          <option key={ip.value} value={ip.value} selected={selected}>
            {ip.name}
          </option>
        );
      });
    return options;
  }

  render() {
    let count = 0;
    if (this.props.companies.meta) {
      count = this.props.companies.meta.count;
    }
    return (
      <div className="superwide">
        <div className="row">
          <h1>
            Admin - Companies
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                params={this.props.params}
              />
            </div>
          </h1>
        </div>
        <div>{this.renderCompanies()}</div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { companies: state.company.all };
}

export default connect(
  mapStateToProps,
  { fetchCompanies, enableCompany, disableCompany, pokeCompanyLeadRouterRelation, changeCompanyIp, changeCompanyDomain }
)(AdminCompanies);
